export var ctaPreFooterData = {
    title: "Still not sure what you’re looking for?",
    body: "Need a little help deciding on your next motor? Get the inside scoop from our car fanatics"
};
